module.exports = __webpack_public_path__ + "static/img/fangkong.0db9e1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fangkong.png
// module id = NNQC
// module chunks = 1